import {Component, OnInit} from '@angular/core';
import {LayoutService} from './service/app.layout.service';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
  model: any[] = [];
  roles: string[] = [];

  constructor(public layoutService: LayoutService) {
  }

  ngOnInit() {
    this.model = [
      {
        label: 'Home',
        role: '',
        items: [
          {
            label: 'Dashboard',
            icon: 'pi pi-fw pi-home',
            routerLink: ['/'],
            role: '',
          },
        ],
      },
      {
        label: 'Administração',
        role: 'ROLE_ADMIN_MASTER',
        items: [
          {
            label: 'Servidores',
            icon: 'pi pi-fw pi-check-square',
            routerLink: ['/administracao/infra/servidores'],
            role: 'ROLE_ADMIN_MASTER_INFRA',
          },
          {
            label: 'Clientes',
            icon: 'pi pi-fw pi-check-square',
            routerLink: ['/administracao/clientes'],
            role: 'ROLE_ADMIN_MASTER_CLIENTES',
          },
          {
            label: 'Perfil',
            icon: 'pi pi-fw pi-check-square',
            routerLink: ['/administracao/perfil'],
            role: 'ROLE_ADMIN_MASTER_ACESSOS',
          }
        ],
      },
      {
        label: 'Administração - Cliente',
        role: 'ROLE_ADMIN_CLIENTE',
        items: [
          {
            label: 'Usuários',
            icon: 'pi pi-fw pi-check-square',
            routerLink: ['/administracao/usuarios'],
            role: 'ROLE_ADMIN_CLIENTE_USUARIOS',
          },
          {
            label: 'Perfil',
            icon: 'pi pi-fw pi-check-square',
            routerLink: ['/administracao/perfil'],
            role: 'ROLE_ADMIN_CLIENTE_PERFIS',
          },
          {
            label: 'Função',
            icon: 'pi pi-fw pi-check-square',
            routerLink: ['/administracao/funcao'],
            role: 'ROLE_ADMIN_CLIENTE_PERFIS',
          }
        ],
      },
      {
        label: 'Integrações',
        role: 'ROLE_INTEG',
        items: [
          {
                label: 'Aprovações',
                icon: 'pi pi-fw pi-check-circle',
                routerLink: ['/workflow'],
                role: 'ROLE_INTEG_APROVACAO_WORKFLOW',
          },
          {
            label: 'Parametrizações',
            icon: 'pi pi-wrench',
            role: 'ROLE_INTEG_PARAM',
            items: [
              {
                label: 'Geral',
                icon: 'pi pi-fw pi-circle',
                routerLink: ['/integracoes/parametrizacao'],
                role: 'ROLE_INTEG_PARAM_GERAL',
              },
              {
                label: 'Provisão 77P',
                icon: 'pi pi-fw pi-gauge',
                routerLink: ['/integracoes/movimentacoes/provisao77p'],
                role: 'ROLE_INTEG_PARAM_PROV',
              },
              {
                label: 'Classe Avaliação',
                icon: 'pi pi-fw pi-gauge',
                routerLink: ['/integracoes/movimentacoes/classeavaliacao'],
                role: 'ROLE_INTEG_PARAM_CLASAVAL',
              },
              {
                label: 'Produção Indústrial',
                icon: 'pi pi-fw pi-gauge',
                routerLink: ['/integracoes/movimentacoes/producaoparam'],
                role: 'ROLE_INTEG_PARAM_PRODUCAO',
              },
              {
                label: 'Pesagens 91p',
                icon: 'pi pi-fw pi-gauge',
                routerLink: ['/integracoes/movimentacoes/pesagem91p'],
                role: 'ROLE_INTEG_PARAM_PESAGEM',
              },
              {
                label: 'Notas',
                icon: 'pi pi-fw pi-gauge',
                routerLink: ['/integracoes/movimentacoes/nota'],
                role: 'ROLE_INTEG_PARAM_NOTAS',
              },
              {
                label: 'TMA',
                icon: 'pi pi-fw pi-gauge',
                routerLink: ['/integracoes/movimentacoes/tma'],
                role: 'ROLE_INTEG_MOVIMEN_CONTRATO',
              },
              {
                label: 'Responsável x Depósito',
                icon: 'pi pi-fw pi-users',
                routerLink: ['/integracoes/movimentacoes/transferencia-insumos/deposito-responsavel'],
                role: 'ROLE_INTEG_PARAM_TRANSF_RESP_DEP',
              },
              {
                label: 'Balança',
                icon: 'pi pi-fw pi-sliders-h',
                routerLink: ['/integracoes/parametrizacao/balanca'],
                role: 'ROLE_INTEG_PARAM_BALANCA',
              },
              {
                label: 'Análise Pesagem',
                icon: 'pi pi-fw pi-chart-bar',
                routerLink: ['/integracoes/parametrizacao/analisepesagem'],
                role: 'ROLE_INTEG_PARAM_ANALISE_PESAGEM',
              },
              {
                label: 'Workflows',
                icon: 'pi pi-fw pi-gauge',
                routerLink: ['/administracao/workflows'],
                role: 'ROLE_INTEG_PARAM_WORKFLOW',
              },
            ]
          },
          {
            label: 'Dados Mestre',
            icon: 'pi pi-fw pi-id-card',
            role: 'ROLE_INTEG_MESTRES',
            items: [
              {
                label: 'Unidades de Medidas',
                icon: 'pi pi-fw pi-circle',
                routerLink: ['/integracoes/dadosmestres/unidadesmedidas'],
                role: 'ROLE_INTEG_MESTRES_UM',
              },
              {
                label: 'Municípios',
                icon: 'pi pi-fw pi-circle',
                routerLink: ['/integracoes/dadosmestres/municipios'],
                role: 'ROLE_INTEG_MESTRES_MUN',
              },
              {
                label: 'Depósitos',
                icon: 'pi pi-fw pi-box',
                routerLink: ['/integracoes/dadosmestres/depositos'],
                role: 'ROLE_INTEG_MESTRES_DEPOSITO',
              },
              {
                label: 'Equipamentos',
                icon: 'pi pi-fw pi-car',
                routerLink: ['/integracoes/dadosmestres/equipamentos'],
                role: 'ROLE_INTEG_MESTRES_EQUIPAMENTOS',
              },
              {
                label: 'Materiais',
                icon: 'pi pi-fw pi-wrench',
                routerLink: ['/integracoes/dadosmestres/materiais'],
                role: 'ROLE_INTEG_MESTRES_MAT',
              },
              {
                label: 'Fornecedores',
                icon: 'pi pi-fw pi-user',
                routerLink: ['/integracoes/dadosmestres/fornecedores'],
                role: 'ROLE_INTEG_MESTRES_FORNEC',
              },
              {
                label: 'Grupos Materiais',
                icon: 'pi pi-fw pi-user',
                routerLink: ['/integracoes/dadosmestres/gruposmateriais'],
                role: 'ROLE_INTEG_MESTRES_GRPMAT',
              },
              {
                label: 'TMA',
                icon: 'pi pi-fw pi-wrench',
                routerLink: ['/integracoes/dadosmestres/materiais'],
                role: 'ROLE_INTEG_MESTRES_MAT',
              },
              {
                label: 'Centro de Custos',
                icon: 'pi pi-fw pi-wrench',
                routerLink: ['/integracoes/dadosmestres/centrocustos'],
                role: 'ROLE_INTEG_MESTRES_CENTROCUSTOS',
              },
              {
                label: 'Contas Contabeis',
                icon: 'pi pi-fw pi-wrench',
                routerLink: ['/integracoes/dadosmestres/contascontabeis'],
                role: 'ROLE_INTEG_MESTRES_CONTASCONTAB',
              },
            ],
          },
          {
            label: 'Movimentações',
            icon: 'pi pi-fw pi-check-square',
            role: 'ROLE_INTEG_MOVIMEN',
            items: [
              {
                label: 'Baixa de Insumo',
                icon: 'pi pi-fw pi-shopping-bag',
                routerLink: ['/integracoes/movimentacoes/consumiveis'],
                role: 'ROLE_INTEG_MOVIMEN_BAIXA',
              }, {
                label: 'Pesagens',
                icon: 'pi pi-fw pi-gauge',
                routerLink: ['/integracoes/movimentacoes/pesagens'],
                role: 'ROLE_INTEG_MOVIMEN_PESAGEM',
              }, {
                label: 'Balança',
                icon: 'pi pi-fw pi-gauge',
                routerLink: ['/integracoes/movimentacoes/capturapeso'],
                role: 'ROLE_INTEG_MOVIMEN_BALANCA',
              },/*{
                label: 'Depreciações',
                icon: 'pi pi-fw pi-gauge',
                routerLink: ['/integracoes/movimentacoes/depreciacoes'],
                role: 'ROLE_INTEG_MOVIMEN_DEPREC',
              },*/{
                label: 'Produção Industrial',
                icon: 'pi pi-fw pi-box',
                routerLink: ['/integracoes/movimentacoes/producaos'],
                role: 'ROLE_INTEG_MOVIMEN_PRODIND',
              }, {
                label: 'ADTO Folha Fornecedor',
                icon: 'pi pi-fw pi-forward',
                routerLink: ['/integracoes/movimentacoes/adiantamentos'],
                role: 'ROLE_INTEG_MOVIMEN_ADIANT',
              },
              {
                label: 'Nota Fiscal',
                icon: 'pi pi-fw pi-file',
                routerLink: ['/integracoes/movimentacoes/notafiscals'],
                role: 'ROLE_INTEG_MOVIMEN_NOTAFIS',
              },
              {
                label: 'Buscar Nota Fiscal',
                icon: 'pi pi-fw pi-search',
                routerLink: ['/integracoes/movimentacoes/buscanotafiscal'],
                role: 'ROLE_INTEG_MOVIMEN_NOTAFIS',
              },
              {
                label: 'Provisão',
                icon: 'pi pi-fw pi-clock',
                routerLink: ['/integracoes/movimentacoes/provisoes'],
                role: 'ROLE_INTEG_MOVIMEN_PROV',
              },
              {
                label: 'Serviços',
                icon: 'pi pi-fw pi-wrench',
                routerLink: ['/integracoes/movimentacoes/servicos'],
                role: 'ROLE_INTEG_MOVIMEN_SERV',
              },
              {
                label: 'Custos',
                icon: 'pi pi-fw pi-dollar',
                routerLink: ['/integracoes/movimentacoes/custo'],
                role: 'ROLE_INTEG_MOVIMEN_CUSTO',
              },
              {
                label: 'Fluxo de Caixa',
                icon: 'pi pi-fw pi-money-bill',
                routerLink: ['/integracoes/movimentacoes/fluxocaixa'],
                role: 'ROLE_INTEG_MOVIMEN_FLUXOCAIXA'
              },
              {
                label: 'Produção Retorno',
                icon: 'pi pi-fw pi-refresh',
                routerLink: ['/integracoes/movimentacoes/producaoretorno'],
                role: 'ROLE_INTEG_MOVIMEN_PRODUCAOIND'
              },
              {
                label: 'Abastecimentos e Lubrificantes',
                icon: 'pi pi-fw pi-shopping-bag',
                routerLink: ['/integracoes/movimentacoes/abastecimentos-lubrificantes'],
                role: 'ROLE_INTEG_ABAST_LUBS',
              },
              {
                label: 'Transferência de Insumos',
                icon: 'pi pi-fw pi-shopping-bag',
                routerLink: ['/integracoes/movimentacoes/transferencia-insumos'],
                role: 'ROLE_INTEG_TRANSF_INSUMOS',
              },
              {
                label: 'Contratos',
                icon: 'pi pi-fw pi-arrow-circle-down',
                routerLink: ['/integracoes/movimentacoes/contratos/integracao-padrao'],
                role: 'ROLE_INTEG_MOVIMEN_CONTRATO_PADRAO',
              },
              {
                label: 'RE',
                icon: 'pi pi-fw pi-expand',
                routerLink: ['/integracoes/movimentacoes/contratos'],
                role: 'ROLE_INTEG_MOVIMEN_CONTRATO',
                items: [
                  {
                    label: 'Integração',
                    icon: 'pi pi-fw pi-arrow-circle-down',
                    routerLink: ['/integracoes/movimentacoes/contratos/integracao'],
                    role: 'ROLE_INTEG_MOVIMEN_CONTRATO',
                  },
                  {
                    label: 'Contratos',
                    icon: 'pi pi-fw pi-copy',
                    routerLink: ['/integracoes/movimentacoes/contratos'],
                    role: 'ROLE_INTEG_MOVIMEN_CONTRATO',
                    items: [
                      {
                        label: 'Novos',
                        icon: 'pi pi-fw pi-file-plus',
                        routerLink: ['/integracoes/movimentacoes/contratos/novos'],
                        role: 'ROLE_INTEG_MOVIMEN_CONTRATO',
                      },
                      {
                        label: 'Modificados',
                        icon: 'pi pi-fw pi-file-edit',
                        routerLink: ['/integracoes/movimentacoes/contratos/modificados'],
                        role: 'ROLE_INTEG_MOVIMEN_CONTRATO',
                      },
                      {
                        label: 'Integrados',
                        icon: 'pi pi-fw pi-file-check',
                        routerLink: ['/integracoes/movimentacoes/contratos/integrados'],
                        role: 'ROLE_INTEG_MOVIMEN_CONTRATO',
                      },
                      {
                        label: 'Finalizados PIMS',
                        icon: 'pi pi-fw pi-folder-open',
                        routerLink: ['/integracoes/movimentacoes/contratos/cancelados/pendentes'],
                        role: 'ROLE_INTEG_MOVIMEN_CONTRATO',
                      },
                      {
                        label: 'Finalizados',
                        icon: 'pi pi-fw pi-folder',
                        routerLink: ['/integracoes/movimentacoes/contratos/cancelados'],
                        role: 'ROLE_INTEG_MOVIMEN_CONTRATO',
                      },
                      {
                        label: 'Com erros',
                        icon: 'pi pi-fw pi-file-excel',
                        routerLink: ['/integracoes/movimentacoes/contratos/erros'],
                        role: 'ROLE_INTEG_MOVIMEN_CONTRATO',
                      },
                    ]
                  },
                  {
                    label: 'Pagamentos',
                    icon: 'pi pi-fw pi-dollar',
                    role: 'ROLE_INTEG_MOVIMEN_CONTRATO',
                    items: [
                      {
                        label: 'Pagamento não integrados',
                        icon: 'pi pi-fw pi-file-import',
                        routerLink: ['/integracoes/movimentacoes/contratos/nao-integrados'],
                        role: 'ROLE_INTEG_MOVIMEN_CONTRATO',
                      },
                      {
                        label: 'Envio de Folha',
                        icon: 'pi pi-fw pi-file-arrow-up',
                        routerLink: ['/integracoes/movimentacoes/contratos/pagamento'],
                        role: 'ROLE_INTEG_MOVIMEN_CONTRATO',
                      },
                    ]
                  },
                  {
                    label: 'Processos',
                    icon: 'pi pi-fw pi-cog',
                    routerLink: ['/integracoes/movimentacoes/contratos/processos'],
                    role: 'ROLE_INTEG_MOVIMEN_CONTRATO',
                  },
                ]
              }
            ],
          }
        ],
      },
      {
        label: 'SmartInteg',
        icon: 'pi pi-fw pi-sitemap',
        role: 'ROLE_SMARTINTEG',
        items: [
          {
            label: 'Dashboard',
            icon: 'pi pi-fw pi-home',
            routerLink: ['/smartinteg/dashboard'],
            role: 'ROLE_SMARTINTEG_ADMIN',
          },
          {
            separator: true
          },
          {
            label: 'Provedores',
            icon: 'pi pi-fw pi-database',
            routerLink: ['/smartinteg/provedores'],
            role: 'ROLE_SMARTINTEG_ADMIN',
          },
          {
            label: 'Processos',
            icon: 'pi pi-fw pi-cog',
            routerLink: ['/smartinteg/processos'],
            role: 'ROLE_SMARTINTEG_ADMIN',
          },
          {
            separator: true
          },
          {
            label: 'Recursos',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/smartinteg/recursos'],
            role: 'ROLE_SMARTINTEG_ADMIN',
          },
          {
            label: 'Comandos',
            icon: 'pi pi-fw pi-code',
            routerLink: ['/smartinteg/comandos'],
            role: 'ROLE_SMARTINTEG_ADMIN',
          },
          {
            label: 'Mapeamentos',
            icon: 'pi pi-fw pi-arrows-h',
            routerLink: ['/smartinteg/mapeamentos'],
            role: 'ROLE_SMARTINTEG_ADMIN',
          },
          {
            label: 'Publicações',
            icon: 'pi pi-fw pi-globe',
            routerLink: ['/smartinteg/publicacoes'],
            role: 'ROLE_SMARTINTEG_ADMIN',
          },
          {
            separator: true
          },
          {
            label: 'Monitoramento',
            icon: 'pi pi-fw pi-chart-bar',
            role: 'ROLE_SMARTINTEG_PROCESSO',
            items: [
              {
                label: 'Dashboard Monitor',
                icon: 'pi pi-fw pi-chart-line',
                routerLink: ['/smartinteg/monitor/dashboard'],
                role: 'ROLE_SMARTINTEG_PROCESSO',
              },
              {
                label: 'Status Processos',
                icon: 'pi pi-fw pi-check-circle',
                routerLink: ['/smartinteg/monitor/processos'],
                role: 'ROLE_SMARTINTEG_PROCESSO',
              },
            ]
          }
        ]
      },
      {
        label: 'Monitor de Insumos',
        role: 'ROLE_MONITORINSUMO',
        items: [
          {
            label: 'Material Exceção',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/painelinsumos/insumoExcecao'],
            role: 'ROLE_MONITORINSUMO_MATEXC'
          },
          {
            label: 'Depósitos',
            icon: 'pi pi-fw pi-database',
            routerLink: ['/painelinsumos/deposito'],
            role: 'ROLE_MONITORINSUMO_DEPOSITO'
          },
          {
            label: 'Painel Insumos',
            icon: 'pi pi-fw pi-arrow-right-arrow-left',
            routerLink: ['/painelinsumos/painel'],
            role: 'ROLE_MONITORINSUMO_PAINEL'
          }
        ]
      },
      {
        label: 'Produção Análises',
        role: 'ROLE_PRODUCAO_ANALISE',
        items: [
          {
            label: 'Campos',
            icon: 'pi pi-fw pi-objects-column',
            routerLink: ['/producao-analise/campos'],
            role: 'ROLE_PRODUCAO_ANALISE_CAMPOS',
          },
          {
            label: 'Variáveis',
            icon: 'pi pi-fw pi-cog',
            routerLink: ['/producao-analise/variaveis'],
            role: 'ROLE_PRODUCAO_ANALISE_VARIAVEIS',
          },
          {
            label: 'Análises',
            icon: 'pi pi-fw pi-chart-scatter',
            routerLink: ['/producao-analise/analises'],
            role: 'ROLE_PRODUCAO_ANALISE_ANALISES',
          }
        ]
      }
    ];

    this.roles = this.getRoles();

    this.model = this.filtrarPermissoes(this.model, this.roles)

     //this.model = this.model.filter(item => this.roles.includes(item.role) || item.role === '');
  }

  getRoles(): string[] {
    const roles = JSON.parse(localStorage.getItem('roles') || '[]');
    return roles || [];
  }

  filtrarPermissoes(items: any[], roles: any[]) {
    return items
      .filter(item => roles.includes(item.role) || item.role === '')
      .map(item => {
        if (item.items) {
          item.items = this.filtrarPermissoes(item.items, roles)
        }
        return item;
      })
    //.filter(item => item.items ? item.items.length > 0 : true);
  }
}
